import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/components/Pages/HomePage'
import PartnersPage from '@/components/Pages/PartnersPage'
import SpeakersPage from '@/components/Pages/SpeakersPage'
import CooperationPage from '@/components/Pages/CooperationPage'
import AboutUs from '@/components/Pages/AboutUs'
import Timetable from '@/components/Pages/Timetable'
import Post from '@/components/Posts/Post'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      meta: {
        title: 'Radiokids.Online - Перше україньке дитяче онлайн радіо'
      }
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      component: AboutUs,
      meta: {
        title: 'Radiokids.Online - Про нас'
      }
    },
    {
      path: '/timetable',
      name: 'Timetable',
      component: Timetable,
      meta: {
        title: 'Radiokids.Online - Програма передач'
      }
    },
    {
      path: '/speakers',
      name: 'SpeakersPage',
      component: SpeakersPage,
      meta: {
        title: 'Radiokids.Online - Наші диктори'
      }
    },
    {
      path: '/partners',
      name: 'PartnersPage',
      component: PartnersPage,
      meta: {
        title: 'Radiokids.Online - Партнери'
      }
    },
    {
      path: '/cooperation',
      name: 'CooperationPage',
      component: CooperationPage,
      meta: {
        title: 'Radiokids.Online - Співпраця'
      }
    },
    {
      path: '/articles/:code',
      name: 'Post',
      component: Post,
      meta: {
        title: ''
      }
    }
  ]
})

// @see https://alligator.io/vuejs/vue-router-modify-head/
// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js